import React from 'react';
import { useTranslation } from 'hooks';
import './labelStatus.scss';

export type Status =
  | 'success'
  | 'active'
  | 'info'
  | 'error'
  | 'warning'
  | 'processing'
  | 'blackline';

interface Props {
  text: string | React.ReactNode;
  status?: Status;
  customClass?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const LabelStatus: React.FC<Props> = ({
  text,
  status,
  customClass = '',
  onClick,
}) => {
  const getTranslate = useTranslation();

  const renderContent = () => {
    if (typeof text === 'string') {
      return getTranslate(text).toLowerCase();
    }
    return text;
  };

  return (
    <div
      className={`ui-label-status ui-label-status_${status} ${customClass}`}
      onClick={onClick}>
      <span className='utils-overflow-dots'>
        {renderContent()}
      </span>
    </div>
  );
};

export default LabelStatus;
